export const LABEL_COLUMNS = ['labels', 'label', 'tags', 'tag'];

// Minimal quote-aware splitter. Enough to read headers and pull one column out;
// the backend re-parses the file properly and owns the authoritative result.
export const splitCsvRow = row => {
  const fields = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < row.length; i += 1) {
    const char = row[i];

    if (char === '"') {
      if (inQuotes && row[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      fields.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  fields.push(current);
  return fields.map(field => field.trim());
};

const splitRows = text =>
  text
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .filter(row => row.trim() !== '');

/**
 * Checks an audience CSV before upload.
 * @returns {{valid: boolean, error: string|null, labelColumn: string|null, rowCount: number, rowsWithoutLabel: number}}
 */
export const validateAudienceCsv = text => {
  const rows = splitRows(text);
  const result = {
    valid: false,
    error: null,
    labelColumn: null,
    rowCount: 0,
    rowsWithoutLabel: 0,
  };

  if (rows.length === 0) return { ...result, error: 'EMPTY' };

  const headers = splitCsvRow(rows[0]).map(header => header.toLowerCase());
  const labelIndex = headers.findIndex(header =>
    LABEL_COLUMNS.includes(header)
  );

  if (labelIndex === -1) return { ...result, error: 'MISSING_LABEL_COLUMN' };

  const dataRows = rows.slice(1);
  if (dataRows.length === 0) return { ...result, error: 'NO_ROWS' };

  const rowsWithoutLabel = dataRows.filter(
    row => !splitCsvRow(row)[labelIndex]
  ).length;

  return {
    valid: rowsWithoutLabel === 0,
    error: rowsWithoutLabel > 0 ? 'ROWS_MISSING_LABEL' : null,
    labelColumn: headers[labelIndex],
    rowCount: dataRows.length,
    rowsWithoutLabel,
  };
};
